import {
  fetchWorkflowDefinitionsAPIByProgramService,
  useTenantNavigate,
} from '@app-store'
import {
  Accordion,
  ConfirmationModal,
  CustomButton,
  DropdownType,
  FIELD_VALUE_CONSTANTS,
  Modal,
  PageTitle,
  SelectDropDown,
  SvgCollapsePanel,
  SvgVerticalSplitter,
  TabInterface,
  Tabs,
  ConfirmDialogWithReason,
  ACTION_ICONS_NAMESPACE,
  MODE_CONSTANTS,
  TableActionType,
  ActionPopUp,
  SvgCross,
  SvgReload,
} from '@ui-kit'
import {
  BUTTONS,
  ENTITY_ID,
  ENTITY_NAME,
  INTERACTION_STATUS,
  INTERACTION_STATUS_KEYS,
  // INTERACTION_STATUS,
  // INTERACTION_STATUS_KEYS,
  LAYOUT_TYPE_NAMESPACE,
  NAMESPACES,
  WORKFLOW_STATUS,
  // WORKFLOW_STATUS,
} from '../../utils/constants'
import { AWS_ENCRYPTION_KEY } from '../../utils/constants'
import {
  APPLICATION_PREFERENCES_STRINGS,
  AWS_STRINGS,
  CALL_INTERACTION_STRINGS,
  CALL_INTERACTIONS,
  DUPLICATION,
  REQUESTOR_MESSAGES,
} from '../../utils/strings'
import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import CryptoJS from 'crypto-js'
import { createPortal } from 'react-dom'
import {
  addToaster,
  DataTypeStore,
  getAllLayoutApi,
  getProgramsList,
  hideLoader,
  LayoutResponseType,
  showLoader,
  WorkflowInstanceType,
  WorkflowProcessType,
  WorkflowDefinitionsListType,
  createWorkflowInstance,
  getWorkflowByEntityNameAndRecordId,
  getEntityDataByEntityNameIdApiForFilter,
  getLayoutTree,
  updateRelationshipTree,
  flattenEntityRelationshipTree,
  updateRelationshipTreeObject,
  getEntityList,
  fetchServiceListAPI,
  updateIntakeCommunicationMap,
  getCategoryDropdownOptions,
  fetchProductListAPI,
  discardFaxById,
  getLayoutByEntityIdAndTypeApi,
  fetchDuplicateRecordsAPI,
  getEntityDataByEntityFilter,
  getInteractionTransitionState,
  setInteractionTransitionState,
  getEntityDataByEntityNameApiForFilter,
  transformToDuplicateApiPayload,
  getAllEntitiesAgentAction,
  setAllCallData,
  updateRequestorConfigReducer,
} from '@app-store'
import type { AwsCallState } from '@app-store'
import { HCPProgramType } from '../../types/permissionAssignment.types'
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../utils/agent.store'
import { useParams, useSearchParams } from 'react-router-dom'
import SearchLayout, { SelectWorkFlowDropDown } from './SearchLayout'
import { callRoute } from '../../routes/route.constant'
import {
  addEntityData,
  editEntityData,
  editEntityDataEmbeddedAPI,
  getEntityData,
  getEntityDataByIdEmbedded,
} from '../../apis/entityData.api'
import { FieldValues } from 'react-hook-form'
import FormRenderer from '../../components/FormRenderer'
import { EntityLayout, LayoutData, Page } from '../../types/layout.types'
import { v4 as uuid } from 'uuid'
import { TOASTER_NAMESPACE } from '../../constants/addEditPage.strings'
import EntityLayoutWrapper from './EntityLayoutWrapper'
import CallInteractionContextProvider, {
  CallInteractionContext,
} from './CallInteactionContext'
import {
  generateTabIndexMap,
  getMaxTabIndexValue,
} from '../../utils/tab-indexing'
import { FocusTrap } from 'focus-trap-react'
import {
  ROWS_TAB_DIFFERENCE,
  ShortcutKeys,
} from '../../constants/form.constants'
import {
  ImperativePanelGroupHandle,
  ImperativePanelHandle,
  Panel,
  PanelGroup,
  PanelResizeHandle,
} from 'react-resizable-panels'
import { getCurrentLocalDate } from '../../utils/date.utils'
import {
  checkIfRecordFieldsEnabled,
  entityMap,
  reverseMappingOfRequestorName,
} from '../../utils/helperFunctions'
import { ListingTableRow } from '../../types/listingTable.types'
import { isEmpty, noop, uniqueId } from 'lodash'
import { ListingTable } from '../../components/listing-table/ListingTable'
import { DuplicationScore } from '../../components/DuplicationScore'
import { Group } from '../../types/types'
import { ListingTableColumn } from '../../utils/types'
import { CaseActionList } from '../../types/reassignCase.types'
import { validatePhoneNumberAndAddress } from '../../utils/form.utils'
// import { CaseActionList } from '../../types/reassignCase.types'

interface WorkflowInstanceAPIType {
  process: WorkflowProcessType
  workflow_instance: WorkflowInstanceType
}

interface EntityDataProps {
  label: string
  value: string
  setViewEntityRecord?: React.Dispatch<
    React.SetStateAction<DataTypeStore | undefined>
  >
  viewEntityRecord?: DataTypeStore
  setTabIndexFromLayout?: (tabIndexVal: number) => void
  isCaseCreated?: boolean
  updatedDataObj?: React.MutableRefObject<{
    channel: string | undefined
    product: string | undefined
    program: string | undefined
    requestor: string | undefined
  }>
  editEntityRecord?: boolean
  setEditEntityRecord?: React.Dispatch<
    React.SetStateAction<boolean | undefined>
  >
  addEntityRecord?: boolean
  setAddEntityRecord?: React.Dispatch<React.SetStateAction<boolean | undefined>>
  setTriggerSearch?: React.Dispatch<React.SetStateAction<boolean | undefined>>
  setRefetch?: React.Dispatch<React.SetStateAction<number>>
}

export const CreateInteraction = () => {
  const dispatch = useAppDispatch()
  const navigate = useTenantNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const { communicationId } = useParams()
  const [programOptions, setProgramOptions] = useState<
    DropdownType<DataTypeStore>[]
  >([])
  const [productOptions, setProductOptions] = useState<DropdownType<string>[]>(
    []
  )
  const [isFocusTrapActive, setIsFocusTrapActive] = useState(false)
  const [selectedProgramId, setSelectedProgramId] = useState<string>()
  const [selectedChannelId, setSelectedChannelId] = useState<string>()
  const [requestorId, setRequestorId] = useState<number | null>(null)
  const [defaultActiveTab, setDefaultActiveTab] = useState<TabInterface>()
  const [selectedProductId, setSelectedProductId] = useState<string>()
  const [viewEntityRecord, setViewEntityRecord] = useState<
    DataTypeStore | undefined
  >()
  const [editEntityRecord, setEditEntityRecord] = useState<
    boolean | undefined
  >()
  const [addEntityRecord, setAddEntityRecord] = useState<boolean | undefined>()
  const [entityDataLeft, setEntityDataLeft] = useState<EntityDataProps>()
  const [entityDataRight, setEntityDataRight] = useState<EntityDataProps>()
  const [workflowList, setWorkflowList] = useState<
    WorkflowDefinitionsListType[]
  >([])
  const [triggerSearch, setTriggerSearch] = useState<boolean>()
  const [interactionTabs, setInteractionTabs] = useState<TabInterface[]>()
  const [currentInteractionTab, setCurrentInteractionTab] =
    useState<TabInterface>()
  const [refetch, setRefetch] = useState<number>(0)
  const [isAwsViewId, setIsAwsViewId] = useState<boolean>(false)
  const awsTriggerRef = useRef<HTMLDivElement | null>(null)
  const [awsDialogPos, setAwsDialogPos] = useState<{
    top: number
    left: number
  }>({ top: 0, left: 0 })
  const params = useParams()
  const interactionStatusEvent = useAppSelector(
    (state) => state?.customEvent?.interactionStatusEvent
  )
  const callerProgramId = useAppSelector((state) => state?.awsCall?.programId)
  const interactionState = useAppSelector(
    (state) => state.awsCall.interactionTransitionState
  )
  const selectedTenantId = useAppSelector(
    (state) => state?.authUser?.selectedClientTenant?.id
  )
  const selectedTenantName = useAppSelector(
    (state) => state.authUser.selectedClientTenant?.name_of_organization
  )
  const relationshipTree = useAppSelector(
    (state) => state?.workflowData?.relationshipTree
  )
  const authUser = useAppSelector((state) => state.authUser)
  const communicationTypes = useAppSelector(
    (state) => state?.categoryDropdown?.categoryMap?.communication_type
  )
  const intakeCommunicationMap = useAppSelector(
    (state) => state?.workflowData?.intakeCommunicationMap
  )
  const callInteractionId = useAppSelector(
    (state) => state?.awsCall?.interactionId
  )
  const incomingCall =
    String(callInteractionId) === String(communicationId) ? true : false
  const associatedRecords = useAppSelector(
    (state) => state?.awsCall?.associatedRecords
  )
  const categoryValue = useAppSelector(
    (state) => state?.categoryDropdown?.categoryMap
  )
  const callType = useAppSelector((state) => state?.awsCall?.callType)
  const [communicationData, setCommunicationData] = useState<FieldValues>({})
  const initialDataObj = useRef<{
    channel: string | undefined
    product: string | undefined
    program: string | undefined
    requestor: string | undefined
  }>({
    channel: '',
    product: '',
    program: '',
    requestor: '',
  })
  const updatedDataObj = useRef<{
    channel: string | undefined
    product: string | undefined
    program: string | undefined
    requestor: string | undefined
  }>({
    channel: '',
    product: '',
    program: '',
    requestor: '',
  })
  const [tabs, setTabs] = useState<TabInterface[]>([])
  const [isLeftPanelExpanded, setIsLeftPanelExpanded] = useState(false)
  const panelGroupRef = useRef<ImperativePanelGroupHandle>(null)
  const leftPanelRef = useRef<ImperativePanelHandle>(null)
  const [isEditMode, setIsEditMode] = useState<Record<number, boolean>>({})
  const [isCaseCreated, setIsCaseCreated] = useState<boolean>(false)
  const [renderRightPanel, setRenderRightPanel] = useState<boolean>(false)
  const [renderKey, setRenderKey] = useState<boolean>(false)
  const [showDiscardModal, setShowDiscardModal] = useState<boolean>(false)
  const [interactionStatus, setInteractionStatus] = useState<FieldValues>()
  const [transitionStateOption, setTransitionStateOptions] =
    useState<CaseActionList[]>()
  const [modal, setModal] = useState<{
    message: string
    state: boolean
    onYesClick?: () => void
    onCancelClick?: () => void
  }>({
    message: '',
    state: false,
  })
  const [tabOffsetFromLeftSection, setTabOffsetFromLeftSection] =
    useState<number>(0)
  const [layoutInfo, setLayoutInfo] = useState<
    {
      layout?: LayoutResponseType | null
      recordData?: FieldValues | null
    }[]
  >([])
  const isProductSet = useRef<boolean>(false)
  const handleIsEditMode = (value: Record<number, boolean>) => {
    setIsEditMode(value)
  }
  const ENCRYPTION_KEY = AWS_ENCRYPTION_KEY
  const decryptParams = (encryptedString: string) => {
    try {
      const decoded = decodeURIComponent(encryptedString)
      const bytes = CryptoJS.AES.decrypt(decoded, ENCRYPTION_KEY)
      const decrypted = bytes.toString(CryptoJS.enc.Utf8)
      return JSON.parse(decrypted)
    } catch (error) {
      console.error('Failed to decrypt params:', error)
      return {}
    }
  }

  const handleModal = (value: {
    message: string
    state: boolean
    onYesClick?: () => void
    onCancelClick?: () => void
  }) => {
    setModal(value)
  }

  const allTabs = useMemo(() => {
    return [
      {
        label: 'Search & Create Case',
        key: 'Search & Create Case',
        component: (
          <div>
            <hr className="my-6" />
            <div className="border border-[#C8C8C8] rounded-[0.5rem] shadow-[0px_4px_4px_-4px_rgba(12,12,13,0.05)]">
              <RecordFields
                selectedProgramId={selectedProgramId}
                selectedProductId={selectedProductId}
                selectedChannelId={selectedChannelId}
                requestorId={requestorId}
                setRequestorId={setRequestorId}
                isLeftPanel={false}
                entityData={entityDataRight}
                setEntityData={setEntityDataRight}
                handleCreateWorkflowInstance={handleCreateWorkflowInstance}
                tabIndex={tabOffsetFromLeftSection}
                receivedDate={
                  communicationData?.created_at
                    ? new Date(communicationData.created_at).toISOString()
                    : ''
                }
                communicationKey={communicationData?.communication_id ?? ''}
                updatedDataObj={updatedDataObj ?? {}}
                initialDataObj={initialDataObj ?? {}}
                interactionStatus={interactionStatus}
                isIncomingCall={incomingCall}
                isOriginInteraction={true}
              />
            </div>
          </div>
        ),
      },
      ...tabs,
    ]
  }, [
    tabs,
    viewEntityRecord,
    tabOffsetFromLeftSection,
    interactionStatus,
    selectedChannelId,
    selectedProgramId,
    selectedProductId,
    entityDataRight,
    communicationData,
    incomingCall,
    requestorId,
  ])

  const handleSetTabs = (workflowIndex: number) => {
    setTabs((prev) => {
      const updatedTabs = [...prev]
      updatedTabs[workflowIndex].label = updatedTabs[
        workflowIndex
      ].label.replace('New Case - ', '')
      return updatedTabs
    })
  }

  async function handleCreateWorkflowInstance(
    process: WorkflowProcessType,
    instance: WorkflowInstanceType
  ) {
    if (instance?.case_id) {
      try {
        dispatch(showLoader())
        const data = {
          communication_cases: [
            {
              id: instance.case_id,
              record_status: 'ACTIVE',
              _state: 'ADDED',
            },
          ],
          ...(selectedProgramId
            ? {
                programs: {
                  id: Number(selectedProgramId),
                  _state: 'CHANGED',
                },
              }
            : {}),
          ...(selectedChannelId
            ? {
                category_communication_type: {
                  id: Number(selectedChannelId),
                  _state: 'CHANGED',
                },
              }
            : {}),
          ...(selectedProductId
            ? {
                products: {
                  id: Number(selectedProductId),
                  _state: 'CHANGED',
                },
              }
            : {}),
        }
        await editEntityDataEmbeddedAPI(
          ENTITY_NAME.COMMUNICATION,
          communicationId ?? '',
          data,
          ['communication_cases', 'programs', 'category_communication_type']
        )
      } catch (err) {
        console.log(err)
      } finally {
        dispatch(hideLoader())
      }
    }
    try {
      dispatch(showLoader())
      const response = await getEntityDataByIdEmbedded(
        process?.global_variables?.entity_name ?? '',
        Number(process?.global_variables?.entity_id),
        [
          process?.global_variables?.config?.case_status ?? '',
          process?.global_variables?.config?.case_id ?? '',
        ],
        instance.case_id ?? ''
      )
      if (response.data) {
        setTabs((prev) => {
          const newTabs = [...prev]
          const newTab = {
            label: `New Case - ${response.data?.case_key}`,
            key: response.data?.case_key,
            component: (
              <EntityLayoutWrapper
                key={response.data?.case_key}
                caseId={instance.case_id}
                definition={process}
                instance={instance}
                workflowIndex={prev.length}
                updateLabel={(workflowIndex?: number) => {
                  if (workflowIndex !== undefined) {
                    handleSetTabs(workflowIndex)
                  }
                }}
                caseDetailsValue={{
                  case_key: response.data.case_key,
                  case_status_id: response.data.case_status_id,
                }}
                interactionStatus={interactionStatus}
                selectedChannelId={selectedChannelId}
              />
            ),
          }
          setDefaultActiveTab(newTab)
          newTabs.push(newTab)
          return newTabs
        })
        setLayoutInfo((prev) => {
          prev.push({
            layout: undefined,
            recordData: undefined,
          })
          return prev
        })
      }
    } catch (err) {
      console.error(err)
    } finally {
      setTimeout(() => dispatch(hideLoader()), 1000)
    }
  }

  const getUniqueEntityTypes = (data: FieldValues): TabInterface[] => {
    return Object.values(data)
      .filter(
        (item) =>
          item != null &&
          Array.isArray(item?.records) &&
          item.records.length > 0
      )
      .map((item) => ({
        label: item.entity_label,
        key: item.entity,
        id: item?.entity_id,
        component: null,
      }))
  }

  const handleInteractionTabClick = (_label: string, index: number) => {
    setCurrentInteractionTab(interactionTabs?.[index])
  }

  const handleProductChange = (e: DropdownType<unknown, string>) => {
    setSelectedProductId(e?.value)
    updatedDataObj.current = {
      ...updatedDataObj.current,
      product: e?.value,
    }
    setRenderKey((prev) => !prev)
  }
  const handleProgramChange = (e: DropdownType<unknown, string>) => {
    setSelectedProgramId(e?.value)
    setSelectedProductId(undefined)
    updatedDataObj.current = {
      ...updatedDataObj.current,
      program: e?.value,
    }
    setRenderKey((prev) => !prev)
  }
  const handleChannelChange = (e: DropdownType<unknown, string>) => {
    setSelectedChannelId(e?.value)
    updatedDataObj.current = {
      ...updatedDataObj.current,
      channel: e?.value,
    }
    setRenderKey((prev) => !prev)
  }

  const fetchPrograms = async () => {
    try {
      dispatch(showLoader())
      const programs = await getProgramsList()
      if (programs?.data?.content) {
        const programOptionsList: DropdownType<DataTypeStore>[] =
          programs?.data?.content
            ?.filter((item: HCPProgramType) => item.enabled)
            ?.map((item: HCPProgramType) => {
              return {
                label: item?.operational_program_name ?? '',
                value: item?.id?.toString() ?? '',
              }
            })
        setProgramOptions([...programOptionsList])
        setSelectedProgramId('')
        setProductOptions([])
      }
    } catch (err) {
      console.log(err)
      setProgramOptions([])
    } finally {
      dispatch(hideLoader())
    }
    fetchCommunications()
  }

  const fetchProducts = async (id: number) => {
    try {
      dispatch(showLoader())
      const response = await fetchProductListAPI(id)
      const products: DropdownType<string>[] = []
      response?.data?.forEach(
        (element: { id: number; trademarked_name: string }) => {
          products.push({
            value: element.id?.toString(),
            label: element.trademarked_name,
          })
        }
      )
      setProductOptions(products)
      if (isProductSet.current) {
        isProductSet.current = false
      } else if (products.length > 0) {
        setSelectedProductId(products[0].value)
        initialDataObj.current = {
          ...initialDataObj.current,
          product: products[0].value,
        }
        updatedDataObj.current = {
          ...updatedDataObj.current,
          product: products[0].value,
        }
      } else setSelectedProductId('')
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }
  const setEntityDataLeftValue = (
    requestorIsPerson:
      | {
          label: string
          value: string
        }
      | undefined,
    case_data: {
      data:
        | {
            requestor?: {
              entity_type?: string
            }
          }
        | undefined
    }
  ) => {
    if (requestorIsPerson) {
      setEntityDataLeft({
        label: case_data.data?.requestor?.entity_type ?? '',
        value: requestorIsPerson?.value ?? '',
      })
    } else {
      setEntityDataLeft(ORGANIZATION_ENTITY)
    }
  }
  const fetchCommunications = async () => {
    try {
      dispatch(showLoader())
      const response = await getEntityDataByEntityNameIdApiForFilter(
        {
          payload: {
            entity_name: ENTITY_NAME.COMMUNICATION,
            page: 0,
            size: 1,
            select: [
              'communication_id',
              'users',
              'created_at',
              'cases',
              'communication_cases',
              'programs',
              'category_communication_type',
              'products',
              'requestor',
              'aws_call_id',
            ],
            related_entities: {
              users: {
                select: ['first_name', 'last_name', 'email'],
              },
              category_communication_type: {
                select: ['name'],
              },
            },
          },
        },
        params?.communicationId ?? ''
      )
      if (response?.data) setCommunicationData(response.data)
      const commonObj = {
        channel: response?.data?.category_communication_type?.id ?? undefined,
        product: response?.data?.products?.id ?? undefined,
        program: response?.data?.programs?.id ?? undefined,
        requestor: response?.data?.requestor?.id ?? undefined,
      }
      initialDataObj.current = { ...commonObj }
      updatedDataObj.current = { ...commonObj }
      if (response?.data?.programs?.id)
        setSelectedProgramId(response?.data?.programs?.id?.toString())
      if (response?.data?.products?.id) {
        setSelectedProductId(response?.data?.products?.id?.toString())
        isProductSet.current = true
      }
      if (response?.data?.requestor?.id) {
        response.data.requestor.entity_type =
          entityMap[response?.data?.requestor.entity_type]
        const requestorIsPerson = PERSON_TYPE_ENTITIES.find(
          (option) => option.label === response?.data?.requestor?.entity_type
        )
        setEntityDataLeftValue(requestorIsPerson, response)
        setViewEntityRecord({
          ...response.data.requestor,
          id: response.data.requestor.record_id,
          requestor_id: response.data.requestor.id,
        })
      }
      if (response?.data?.category_communication_type?.id)
        if (
          callType === AWS_STRINGS.VOICEMAIL &&
          communicationId === callInteractionId
        ) {
          setSelectedChannelId(AWS_STRINGS.VOICEMAIL_ID)
        } else {
          setSelectedChannelId(
            response?.data?.category_communication_type?.id?.toString()
          )
        }
      if (response.data?.communication_cases?.length) {
        try {
          const newTabs = []
          const newEditMode: Record<number, boolean> = {}
          for (let i = 0; i < response.data.communication_cases.length; i++) {
            const comm_case = response.data.communication_cases[i]
            const resp = await getWorkflowByEntityNameAndRecordId({
              entityName: 'case',
              recordId: comm_case.id,
            })
            const case_data = await getEntityDataByEntityNameIdApiForFilter(
              {
                payload: {
                  entity_name:
                    (resp.data as unknown as WorkflowInstanceAPIType).process
                      ?.global_variables?.entity_name ?? '',
                  page: 0,
                  size: 100,
                  select: [
                    (resp.data as unknown as WorkflowInstanceAPIType).process
                      ?.global_variables?.config?.case_status ?? '',
                    (resp.data as unknown as WorkflowInstanceAPIType).process
                      ?.global_variables?.config?.case_id ?? '',
                    'requestor',
                  ],
                  related_entities: {
                    requestor: {
                      select: ['entity_type', 'record_id', 'record_key'],
                    },
                  },
                },
              },
              comm_case.id
            )
            if (case_data.data?.requestor) {
              case_data.data.requestor.entity_type =
                entityMap[case_data?.data?.requestor.entity_type]
              initialDataObj.current = {
                ...initialDataObj.current,
                requestor: case_data?.data?.requestor?.id,
              }
              updatedDataObj.current = {
                ...updatedDataObj.current,
                requestor: case_data?.data?.requestor?.id,
              }
            }
            if (i === 0 && case_data.data?.requestor) {
              const requestorIsPerson = PERSON_TYPE_ENTITIES.find(
                (option) =>
                  option.label === case_data.data?.requestor?.entity_type
              )
              setEntityDataLeftValue(requestorIsPerson, case_data)
              setViewEntityRecord({
                ...case_data.data.requestor,
                id: case_data.data.requestor.record_id,
                requestor_id: case_data.data.requestor.id,
              })
            }
            newTabs.push({
              label: `${case_data.data?.case_key}`,
              key: case_data.data?.case_key,
              component: (
                <EntityLayoutWrapper
                  key={case_data.data?.case_key}
                  caseId={comm_case.id}
                  definition={
                    (resp.data as unknown as WorkflowInstanceAPIType).process
                  }
                  instance={
                    (resp.data as unknown as WorkflowInstanceAPIType)
                      .workflow_instance
                  }
                  workflowIndex={newTabs.length}
                  updateLabel={(workflowIndex?: number) => {
                    if (workflowIndex !== undefined) {
                      setTabs((prev) => {
                        const updatedTabs = [...prev]
                        updatedTabs[workflowIndex].label = updatedTabs[
                          workflowIndex
                        ].label.replace('New Case - ', '')
                        return updatedTabs
                      })
                    }
                  }}
                  caseDetailsValue={{
                    case_key: case_data.data.case_key,
                    case_status_id: case_data.data.case_status_id,
                  }}
                  interactionStatus={interactionStatus}
                  selectedChannelId={selectedChannelId}
                />
              ),
            })
            setLayoutInfo((prev) => {
              prev.push({
                layout: undefined,
                recordData: undefined,
              })
              return prev
            })
            newEditMode[newTabs.length - 1] = false
          }
          setTabs(newTabs)
        } catch (error) {
          console.log(error)
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleSave = async () => {
    if (checkIfRecordFieldsEnabled(false, updatedDataObj, initialDataObj)) {
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.NO_CHANGES_TO_SAVE,
          type: 'info',
          id: uuid(),
        })
      )
      return
    }
    if (isEmpty(selectedProductId)) {
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.SELECT_PRODUCT,
          type: 'error',
          id: uuid(),
        })
      )
      return
    }
    try {
      if (incomingCall) {
        updatedDataObj.current = {
          ...updatedDataObj.current,
          channel: selectedChannelId,
          product: selectedProductId,
          program: selectedProgramId,
        }
      }
      dispatch(showLoader())
      const data = {
        users: {
          id: communicationData?.users?.id,
        },
        ...(selectedChannelId
          ? {
              category_communication_type: {
                id: Number(selectedChannelId),
                _state: 'CHANGED',
              },
            }
          : {}),
        ...(selectedProgramId
          ? {
              programs: {
                id: Number(selectedProgramId),
                _state: 'CHANGED',
              },
            }
          : {}),
        ...(selectedProductId
          ? {
              products: {
                id: Number(selectedProductId),
                _state: 'CHANGED',
              },
            }
          : {}),
        ...(viewEntityRecord
          ? {
              requestor: {
                id: Number(viewEntityRecord.requestor_id),
                _state: 'CHANGED',
              },
            }
          : {}),
      }
      await editEntityDataEmbeddedAPI(
        ENTITY_NAME.COMMUNICATION,
        params?.communicationId ?? '',
        data,
        [
          'users',
          'programs',
          'category_communication_type',
          'products',
          'requestor',
        ]
      )
      initialDataObj.current = {
        channel: updatedDataObj.current.channel,
        product: updatedDataObj.current.product,
        program: updatedDataObj.current.program,
        requestor: updatedDataObj.current.requestor,
      }
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.SAVE_SUCCESS,
          type: 'success',
          id: uuid(),
        })
      )
      setRenderRightPanel((prev) => !prev)
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchWorkFlowInstance = async () => {
    try {
      if (selectedProgramId && selectedProductId) {
        let serviceIds: Set<number> | undefined = undefined
        const allowedServices = await fetchServiceListAPI(
          selectedProgramId,
          selectedProductId
        )
        if (allowedServices?.data) {
          serviceIds = new Set(
            allowedServices.data.map((service: { id: number }) => service.id)
          )
        }
        const searchCriteria = [
          {
            search_key: 'PROGRAM_ID',
            search_value: [selectedProgramId],
            operator: 'EQUALS',
          },
          {
            search_key: 'SERVICE_ID',
            search_value: Array.from(serviceIds ?? []).map(String),
            operator: 'EQUALS',
          },
          {
            search_key: 'INDEPENDENT',
            search_value: ['true'],
            operator: 'EQUALS',
          },
          {
            search_key: 'RECORD_STATUS',
            search_value: ['ACTIVE'],
            operator: 'EQUALS',
          },
          {
            search_key: 'PRODUCT_ID',
            search_value: [selectedProductId],
            operator: 'EQUALS',
          },
        ]
        const response = await fetchWorkflowDefinitionsAPIByProgramService(
          searchCriteria
        )
        if (response?.data) {
          setWorkflowList(
            response.data.content.filter(
              (item: WorkflowDefinitionsListType) =>
                !item.name
                  ?.toLowerCase()
                  .includes(NAMESPACES.DO_NOT_USE?.toLowerCase())
            )
          )
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  const fetchRelationshipTree = async ({ entityId }: { entityId: string }) => {
    try {
      const response = await getLayoutTree(
        entityId || '',
        FIELD_VALUE_CONSTANTS?.ONE?.toString()
      )
      if (response?.data) {
        dispatch(
          updateRelationshipTree(flattenEntityRelationshipTree(response?.data))
        )
        dispatch(
          updateRelationshipTreeObject({
            [response?.data?.entity_name ?? '']: { ...response?.data },
          })
        )
      }
    } catch (error) {
      console.log(error)
    }
  }
  const getEntityIdObj = (
    viewEntityRecord: DataTypeStore | undefined,
    expectedType: string
  ) => {
    return viewEntityRecord?.entity_type === expectedType
      ? {
          id:
            viewEntityRecord?.entity_type === expectedType
              ? Number(viewEntityRecord?.record_id ?? viewEntityRecord?.id)
              : '',
          _state: 'ADDED',
        }
      : undefined
  }

  const getIntakeOptions = useCallback(() => {
    return (communicationTypes ?? [])
      .map((val) => ({
        value: val.label ?? val.value,
        id: val.id,
      }))
      .sort((a, b) => a.value.localeCompare(b.value))
      .reduce(
        (
          acc: {
            value: string
            label: string
          }[],
          option
        ) => {
          if (
            Object.keys(intakeCommunicationMap ?? {}).includes(
              option.id.toString()
            )
          )
            acc.push({
              value: option.id.toString(),
              label: option.value,
            })
          return acc
        },
        []
      )
  }, [communicationTypes, intakeCommunicationMap])

  const createWorkflowInstanceForSelected = async (
    selectedWorkflow: WorkflowDefinitionsListType
  ) => {
    if (!intakeCommunicationMap || !selectedChannelId) return
    let isNewTabPresent = false
    for (const tab of tabs) {
      if (tab.label.includes('New Case')) {
        isNewTabPresent = true
        break
      }
    }
    if (isNewTabPresent) {
      try {
        await new Promise((resolve, reject) => {
          setModal({
            message: NAMESPACES.UNSAVED_CHANGES_MESSAGE,
            state: true,
            onYesClick: () => {
              resolve(true)
            },
            onCancelClick: () => {
              reject(new Error('false'))
            },
          })
        })
        setTabs((prev) => {
          const newTabs = [...prev]
          const newEditMode = { ...isEditMode }
          newTabs.forEach((tab, index) => {
            if (tab.label.includes('New Case')) {
              tab.label = tab.label.replace('New Case - ', '')
              newEditMode[index] = false
            }
          })
          handleIsEditMode(newEditMode)
          return newTabs
        })
      } catch (error) {
        console.error(error)
        return
      }
    }
    const communicationEntity = relationshipTree?.filter(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.communication
          ?.entity_id ?? ENTITY_ID.COMMUNICATION.toString())
    )
    const programEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.program?.entity_id ??
          ENTITY_ID.PROGRAM.toString())
    )
    const productEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.product?.entity_id ??
          ENTITY_ID.PRODUCT.toString())
    )
    const patientEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.patient?.entity_id ??
          ENTITY_ID.PATIENT.toString())
    )
    const providerEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.providers?.entity_id ??
          ENTITY_ID.PROVIDER.toString())
    )
    const requestorEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.requestor?.entity_id ??
          ENTITY_ID.REQUESTOR.toString())
    )
    const userEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.users?.entity_id ??
          ENTITY_ID.USER.toString())
    )
    const caseSummaryEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.case_summary
          ?.entity_id ?? ENTITY_ID.CASE_SUMMARY.toString())
    )
    try {
      dispatch(showLoader())
      const embedded =
        Object?.keys(
          selectedWorkflow?.global_variables?.inherited_variables || {}
        ) || []
      const faxReceivedDate =
        selectedWorkflow?.global_variables?.config_fields?.case
          ?.fax_received_date ?? ''
      const receivedDate = communicationData?.created_at
        ? new Date(communicationData.created_at).toISOString()
        : ''
      const payload: {
        flow_meta_data: {
          process_definition_id: string
          communication_id: string | undefined
        }
        meta_data: {
          entity_name: string
          embedded: (string | undefined)[]
        }
        data: {
          [key: string]:
            | string
            | undefined
            | { id: string | undefined; _state: string }[]
            | number
            | boolean
        }
      } = {
        flow_meta_data: {
          process_definition_id: selectedWorkflow?.id ?? '',
          communication_id: communicationId,
        },
        meta_data: {
          entity_name: selectedWorkflow?.global_variables?.entity_name ?? '',
          embedded: [
            ...embedded,
            programEntity?.field_name ?? '',
            providerEntity?.field_name ?? '',
            patientEntity?.field_name ?? '',
            productEntity?.field_name ?? '',
            requestorEntity?.field_name ?? '',
            userEntity?.field_name ?? '',
            caseSummaryEntity?.field_name ?? '',
            selectedWorkflow?.global_variables?.associated_variables?.document
              ?.parent_entity,
            'intake_channel_id',
            'source_id',
            'case_start_date',
            ...(faxReceivedDate ? [faxReceivedDate] : []),
          ],
        },
        data: {
          ...(selectedWorkflow?.global_variables?.inherited_variables || {}),

          [userEntity?.field_name ?? '']: {
            id: Number(authUser?.user?.id),
            _state: 'ADDED',
          },
          [programEntity?.field_name ?? '']: {
            id: Number(selectedProgramId),
            _state: 'ADDED',
          },
          [productEntity?.field_name ?? '']: {
            id: Number(selectedProductId),
            _state: 'ADDED',
          },
          [providerEntity?.field_name ?? '']: getEntityIdObj(
            viewEntityRecord,
            'Provider'
          ),
          [patientEntity?.field_name ?? '']: getEntityIdObj(
            viewEntityRecord,
            'Patient'
          ),
          [requestorEntity?.field_name ?? '']: viewEntityRecord?.requestor_id
            ? {
                id: viewEntityRecord?.requestor_id,
                _state: 'ADDED',
              }
            : undefined,
          [caseSummaryEntity?.field_name ?? '']: {
            record_status: 'ACTIVE',
            _state: 'CHANGED',
          },
          intake_channel_id: intakeCommunicationMap[selectedChannelId],
          source_id: (communicationData.communication_id ?? '') as string,
          case_start_date: new Date(getCurrentLocalDate()).toISOString(),
          ...(faxReceivedDate ? { [faxReceivedDate]: receivedDate } : {}),
        },
      }
      if (communicationEntity?.length) {
        communicationEntity.forEach((item) => {
          if (item?.field_name) {
            payload.meta_data.embedded.push(item?.field_name)
            payload.data[item.field_name] = [
              {
                id: communicationId,
                _state: 'ADDED',
              },
            ]
          }
        })
      }

      const response = await createWorkflowInstance({
        InstanceId: selectedWorkflow?.id ?? '',
        data: payload,
      })
      if (response?.data && handleCreateWorkflowInstance) {
        handleCreateWorkflowInstance(
          response?.data?.process,
          response?.data?.workflow_instance
        )
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleDiscardConfirm = async (reason: string) => {
    try {
      dispatch(showLoader())
      // You can add your API call here if you want to save the reason
      await discardFaxById({
        id: communicationId ?? '',
        reason: reason,
        reviewer: authUser?.user?.id ?? 0,
      })
      dispatch(
        addToaster({
          message: CALL_INTERACTION_STRINGS.CHANGES_DISCARDED_SUCCESSFULLY,
          type: 'success',
          id: uuid(),
        })
      )
      setShowDiscardModal(false)
      navigate(`/${callRoute}`)
    } catch (err) {
      console.error(err)
      dispatch(
        addToaster({
          message: CALL_INTERACTION_STRINGS.ERROR_DISCARDING_CHANGES,
          type: 'error',
          id: uuid(),
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }
  const getIntakeCommunicationMapping = async () => {
    const commTypes = await getCategoryDropdownOptions('communication_type', [
      'name',
      'value',
      'label',
    ])
    const intakeTypes = await getCategoryDropdownOptions('Intake Channel', [
      'name',
      'value',
      'label',
    ])
    const intakeCommMap: Record<string, string> = {}
    commTypes.data.forEach((comm: (typeof commTypes.data)[0]) => {
      const intake = intakeTypes.data.find(
        (int: (typeof intakeTypes.data)[0]) =>
          int.value?.toLowerCase().startsWith(comm.label?.toLowerCase())
      )
      if (intake) {
        intakeCommMap[comm.id] = intake.id
      }
    })
    dispatch(updateIntakeCommunicationMap(intakeCommMap))
  }

  const getClassName = (viewEntityRecord: DataTypeStore | undefined) => {
    return viewEntityRecord || addEntityRecord ? 'hidden' : 'visible'
  }

  const getClassNameForViewEntitySection = (
    viewEntityRecord: DataTypeStore | undefined,
    addEntityRecord: boolean | undefined
  ) => {
    return viewEntityRecord || addEntityRecord ? 'visible' : 'hidden'
  }

  const fetchInteractionStatus = async () => {
    dispatch(showLoader())
    try {
      const res = await getEntityDataByIdEmbedded(
        ENTITY_NAME.COMMUNICATION,
        ENTITY_ID.COMMUNICATION,
        ['category_status'],
        communicationId ?? ''
      )
      if (res?.data) {
        setInteractionStatus(res?.data)
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchInteractionTransitionStates = async () => {
    try {
      const res = await getInteractionTransitionState()
      if (res?.data) {
        dispatch(setInteractionTransitionState(res?.data))
      }
    } catch (err) {
      console.error(err)
    }
  }

  const transformStatusArray = () => {
    let status: string
    if (
      interactionStatus?.category_status?.label === INTERACTION_STATUS?.RE_OPEN
    ) {
      status = WORKFLOW_STATUS?.OPEN
    } else {
      status = interactionStatus?.category_status?.label
        ?.toUpperCase()
        .replace(/\s+/g, '_')
    }
    let arr = interactionState?.[status as string]
    if (arr && tabs?.length > 0) {
      arr = arr.filter((item) => item.value !== WORKFLOW_STATUS?.DISCARDED)
    }
    if (arr) {
      return arr.map(
        ({
          label,
          value,
          id,
        }: {
          label: string
          value: string
          id: string | number
        }) => ({
          label,
          id,
          key: value,
        })
      )
    }
  }

  const updateInteractionStatus = async (keyName: string) => {
    dispatch(showLoader())
    try {
      if (keyName === INTERACTION_STATUS_KEYS.DISCARDED) {
        setShowDiscardModal(true)
        return
      }
      const statusArray = categoryValue?.communication_status
      const id = statusArray.find((item) => item?.value === keyName)
      await editEntityDataEmbeddedAPI(
        ENTITY_NAME.COMMUNICATION,
        communicationId as string,
        {
          id: communicationId,
          category_status: {
            id: id?.id,
            _state: NAMESPACES.CHANGED,
          },
        },
        ['category_status']
      )
      fetchInteractionStatus()
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const getStatusBgColor = () => {
    switch (interactionStatus?.category_status?.label) {
      case INTERACTION_STATUS.OPEN:
        return 'bg-secondary-50'
      case INTERACTION_STATUS.COMPLETED:
        return 'bg-success-25'
      case INTERACTION_STATUS.RE_OPEN:
        return 'bg-taskStatus-300'
      case INTERACTION_STATUS.CANCELLED:
      case INTERACTION_STATUS.DISCARDED:
      case INTERACTION_STATUS.INVALID_VOICEMAIL:
        return 'bg-error-50'
      default:
        return 'bg-secondary-50'
    }
  }

  useEffect(() => {
    if (incomingCall) {
      const res = getUniqueEntityTypes(associatedRecords)
      setInteractionTabs(res)
      setCurrentInteractionTab(res?.[0])
    }
    if (isEmpty(interactionState)) {
      fetchInteractionTransitionStates()
    }
  }, [refetch, incomingCall])

  useEffect(() => {
    fetchInteractionStatus()
  }, [interactionStatusEvent])

  useEffect(() => {
    if (incomingCall) {
      setSelectedProgramId(callerProgramId)
      if (isEmpty(selectedProductId)) {
        setSelectedProductId(productOptions?.[0]?.value)
      }
      setRenderKey((prev) => !prev)
    }
  }, [programOptions, productOptions])

  useEffect(() => {
    setTransitionStateOptions(transformStatusArray())
  }, [interactionStatus, tabs])

  useEffect(() => {
    fetchPrograms()
  }, [selectedTenantId])

  useEffect(() => {
    if (selectedProgramId) fetchProducts(Number(selectedProgramId))
  }, [selectedProgramId])

  useEffect(() => {
    fetchRelationshipTree({
      entityId: '32',
    })
    if (window.location.href.includes('/case')) {
      navigate(window.location.pathname.split('/case')[0], { replace: true })
    }
    if (!intakeCommunicationMap) getIntakeCommunicationMapping()
  }, [])

  useEffect(() => {
    if (!viewEntityRecord) {
      setTabOffsetFromLeftSection(0)
    }
    if (viewEntityRecord?.requestor_id) {
      setRequestorId(Number(viewEntityRecord.requestor_id))
    }
    updatedDataObj.current = {
      ...updatedDataObj.current,
      requestor: viewEntityRecord?.requestor_id?.toString() || undefined,
    }
    setRenderRightPanel((prev) => !prev)
  }, [viewEntityRecord])

  useEffect(() => {
    if (selectedProductId && selectedProgramId) fetchWorkFlowInstance()
  }, [selectedProductId, selectedProductId])

  useEffect(() => {
    if (tabs.length > 0) {
      setIsCaseCreated(true)
    }
  }, [tabs])

  const queryString = searchParams.toString() //

  useEffect(() => {
    const encryptedData = searchParams.get('data')
    let params: Record<string, string> = {}

    if (encryptedData) {
      params = decryptParams(encryptedData)

      if (params.timestamp) {
        const now = Date.now()
        const paramTime = parseInt(params.timestamp, 10)
        if (isNaN(paramTime) || now - paramTime > 600000) {
          params = {}
        }
      }
    } else {
      params = Object.fromEntries(searchParams.entries())
    }

    const updates: Partial<AwsCallState> = {}

    if (params.incomingCall === '1') {
      updates.incomingCall = true
    }

    if (params.incomingPhoneNumber) {
      updates.incomingPhoneNumber = params.incomingPhoneNumber
    }

    if (params.agentStatus) {
      updates.agentStatus = params.agentStatus
    }

    if (params.callType) {
      updates.callType = params.callType
    }

    if (params.programId) {
      updates.programId = params.programId
    }

    if (params.interactionId) {
      updates.interactionId = params.interactionId
    }

    if (params.fromAccept === '1' && communicationId) {
      updates.interactionId = communicationId

      const updatedParams = new URLSearchParams(searchParams)
      updatedParams.delete('fromAccept')
      setSearchParams(updatedParams, { replace: true })
    }

    if (Object.keys(updates).length > 0) {
      dispatch(setAllCallData(updates))
    }
  }, [communicationId, queryString, dispatch, setSearchParams])

  if (!intakeCommunicationMap) return null
  return (
    <CallInteractionContextProvider
      isEditMode={isEditMode}
      handleIsEditMode={handleIsEditMode}
      modal={modal}
      handleModal={handleModal}
      tabs={tabs}
      setTabs={setTabs}
      viewEntityRecord={viewEntityRecord}
      workflowList={workflowList}
      tabIndexOffset={tabOffsetFromLeftSection}
      setTabOffset={setTabOffsetFromLeftSection}
      layoutInfo={layoutInfo}
      setLayoutInfo={setLayoutInfo}
    >
      <FocusTrap
        active={isFocusTrapActive}
        focusTrapOptions={{
          allowOutsideClick: true,
          escapeDeactivates: true,
          setReturnFocus: false,
          clickOutsideDeactivates: true,
          initialFocus: false,
          onDeactivate: () => {
            setIsFocusTrapActive(false)
          },
        }}
      >
        <div
          className="flex flex-col flex-grow h-full"
          onFocus={() => {
            setIsFocusTrapActive(true)
          }}
        >
          <PanelGroup
            className="w-full h-full"
            direction="horizontal"
            ref={panelGroupRef}
          >
            <div className="flex flex-row h-full gap-1 w-full overflow-hidden">
              <Panel
                className="overflow-y-auto h-full"
                defaultSize={40}
                ref={leftPanelRef}
                minSize={25}
                maxSize={75}
                onResize={(size) => {
                  const isExpanded = size > 50
                  setIsLeftPanelExpanded(isExpanded)
                }}
              >
                <div className="relative flex flex-col h-full gap-y-5 overflow-auto">
                  <div className=" justify-between items-center flex p-3">
                    <PageTitle
                      title={CALL_INTERACTIONS.INTERACTION}
                      subtitle=""
                    />
                    <div className="flex gap-3 items-center">
                      <span
                        className={`font-primary text-sm p-2 rounded-md font-light ${getStatusBgColor()}`}
                      >
                        {interactionStatus?.category_status?.label}
                      </span>
                      <ActionPopUp
                        actions={transitionStateOption ?? []}
                        row={[]}
                        rowIndex={999}
                        onActionClick={(actionKeyName) => {
                          updateInteractionStatus(actionKeyName)
                        }}
                        setRowPosition={noop}
                        isDisabled={
                          transitionStateOption?.length === 0 ? true : false
                        }
                      />
                    </div>
                  </div>
                  <div className="relative flex flex-col h-full gap-y-5 overflow-auto p-3 border border-accent-200 rounded-md">
                    <div className="flex flex-row justify-between items-center ">
                      <span className="font-primary text-xs/5 text-accent-900 font-light ">
                        {CALL_INTERACTIONS.SEARCH_REQUESTOR_HEADING}
                      </span>
                      <div className="flex gap-3 justify-between items-center">
                        {!isCaseCreated ? (
                          <div className="flex gap-3 justify-between items-center">
                            <CustomButton
                              isFilled
                              dataQaId="save"
                              height="h-[1.75rem]"
                              widthClass="w-[3.25rem]"
                              onClick={handleSave}
                            >
                              {BUTTONS.SAVE}
                            </CustomButton>
                            <SvgVerticalSplitter />
                          </div>
                        ) : null}
                        <button
                          onClick={() => {
                            const currentSize =
                              leftPanelRef.current?.getSize?.()
                            if (currentSize === 40) {
                              leftPanelRef.current?.resize(75)
                              setIsLeftPanelExpanded(true)
                            } else {
                              leftPanelRef.current?.resize(40)
                              setIsLeftPanelExpanded(false)
                            }
                          }}
                          className=" rounded-full transition"
                          title={isLeftPanelExpanded ? 'Collapse' : 'Expand'}
                        >
                          <SvgCollapsePanel
                            className={`transition-transform duration-200 ${
                              isLeftPanelExpanded ? 'rotate-180' : ''
                            }`}
                          />
                        </button>
                      </div>
                    </div>
                    <div className="flex flex-col gap-2 items-center w-full shrink-0">
                      <div className="flex mb-3 p-1 justify-around bg-secondary-25 rounded-md border border-border-300 w-full">
                        <div className="flex flex-col justify-center">
                          <label className="font-primary text-xs/5 text-accent-900 font-light">
                            {CALL_INTERACTIONS.INTERACTION_ID}
                          </label>
                          <span className="font-primary text-xs/5 text-accent-600">
                            {communicationData?.communication_id}
                          </span>
                        </div>
                        <div className="flex flex-col justify-center">
                          <label className="font-primary text-xs/5 text-accent-900 font-light">
                            {CALL_INTERACTIONS.AGENT_NAME}
                          </label>
                          <span className="font-primary text-xs/5 text-accent-600">
                            {`${communicationData?.users?.first_name ?? ''} ${
                              communicationData?.users?.last_name ?? ''
                            }`}
                          </span>
                        </div>
                        <div className="flex flex-col justify-center">
                          <label className="font-primary text-xs/5 text-accent-900 font-light">
                            {CALL_INTERACTIONS.AGENT_EMAIL}
                          </label>
                          <span className="font-primary text-xs/5 text-accent-600">
                            {communicationData?.users?.email}
                          </span>
                        </div>
                        {communicationData?.aws_call_id && (
                          <div className="flex flex-col justify-center relative">
                            <label className="font-primary text-xs/5 text-accent-900 font-light">
                              {CALL_INTERACTIONS.AWS_CONTACT_ID}
                            </label>
                            <div
                              ref={awsTriggerRef}
                              onClick={() => {
                                const rect =
                                  awsTriggerRef.current?.getBoundingClientRect()
                                if (rect) {
                                  setAwsDialogPos({
                                    top: rect.bottom + window.scrollY + 8,
                                    left: rect.left + window.scrollX,
                                  })
                                }
                                setIsAwsViewId((prev) => !prev)
                              }}
                              className="inline-block w-fit"
                            >
                              <span className="font-primary text-xs/5 text-secondary-300 cursor-pointer hover:underline">
                                {CALL_INTERACTIONS.VIEW_ID}
                              </span>
                            </div>

                            {isAwsViewId &&
                              createPortal(
                                <div
                                  role="dialog"
                                  aria-modal="true"
                                  className="rounded-lg border border-gray-200 bg-white p-4 shadow-lg"
                                  style={{
                                    position: 'absolute',
                                    top: awsDialogPos.top,
                                    left: awsDialogPos.left,
                                    width: 380,
                                    zIndex: 9999,
                                  }}
                                >
                                  <div className="flex items-center justify-between mb-2">
                                    <span className="text-sm font-semibold text-gray-900">
                                      {CALL_INTERACTIONS.AWS_CONTACT_ID}
                                    </span>
                                    <button
                                      onClick={() => setIsAwsViewId(false)}
                                      className="text-gray-500 hover:text-gray-700"
                                    >
                                      <SvgCross />
                                    </button>
                                  </div>

                                  <div className="rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-800">
                                    {communicationData?.aws_call_id}
                                  </div>
                                </div>,
                                document.body
                              )}
                          </div>
                        )}
                      </div>
                      <div className="grid grid-cols-3 gap-x-4 flex-1 w-full">
                        <SelectDropDown
                          label={CALL_INTERACTIONS.CHANNEL}
                          options={getIntakeOptions()}
                          name=""
                          onChange={handleChannelChange}
                          dataQaId="channel"
                          className="bg-white"
                          required={true}
                          defaultValue={selectedChannelId}
                          disabled={isCaseCreated}
                        />
                        <SelectDropDown
                          label={CALL_INTERACTIONS.PROGRAM}
                          options={programOptions}
                          name=""
                          onChange={handleProgramChange}
                          dataQaId="program"
                          className="bg-white"
                          defaultValue={selectedProgramId ?? ''}
                          required={true}
                          disabled={isCaseCreated || incomingCall}
                        />
                        <SelectDropDown
                          label={CALL_INTERACTIONS.PRODUCT}
                          options={productOptions}
                          name=""
                          onChange={handleProductChange}
                          dataQaId="product"
                          className="bg-white"
                          defaultValue={selectedProductId ?? ''}
                          required={true}
                          disabled={isCaseCreated}
                        />
                      </div>
                    </div>
                    {interactionTabs &&
                    interactionTabs?.length > 1 &&
                    incomingCall &&
                    selectedProgramId &&
                    selectedChannelId &&
                    !(viewEntityRecord || addEntityRecord) ? (
                      <>
                        <Tabs
                          tabs={interactionTabs}
                          onChange={handleInteractionTabClick}
                        />
                        <div className="overflow-auto">
                          {(viewEntityRecord || addEntityRecord) &&
                          entityDataLeft ? (
                            <div
                              className={`${getClassNameForViewEntitySection(
                                viewEntityRecord,
                                addEntityRecord
                              )}`}
                            >
                              <ViewEntitySection
                                label={
                                  PERSON_TYPE_ENTITIES.find(
                                    (entity) =>
                                      entity.label ===
                                      (entityMap[entityDataLeft.label] ??
                                        entityDataLeft.label)
                                  )
                                    ? entityDataLeft.label
                                    : ORGANIZATION_ENTITY.label
                                }
                                value={
                                  PERSON_TYPE_ENTITIES.find(
                                    (entity) =>
                                      entity.label ===
                                      (entityMap[entityDataLeft.label] ??
                                        entityDataLeft.label)
                                  )
                                    ? entityDataLeft.value
                                    : ORGANIZATION_ENTITY.value
                                }
                                setViewEntityRecord={(record) => {
                                  setViewEntityRecord(record)
                                  setRenderKey((prev) => !prev)
                                }}
                                viewEntityRecord={viewEntityRecord}
                                isCaseCreated={isCaseCreated}
                                editEntityRecord={editEntityRecord}
                                setEditEntityRecord={(value) => {
                                  setEditEntityRecord(value)
                                }}
                                addEntityRecord={addEntityRecord}
                                setAddEntityRecord={(value) => {
                                  setAddEntityRecord(value)
                                }}
                                setTriggerSearch={setTriggerSearch}
                                setRefetch={setRefetch}
                              />
                            </div>
                          ) : null}
                          {selectedProgramId && selectedChannelId ? (
                            <div
                              className={`${getClassName(viewEntityRecord)}`}
                            >
                              <Accordion
                                heading={
                                  CALL_INTERACTIONS.SEARCH_REQUESTOR_INFORMATION
                                }
                                isDefaultActive
                              >
                                <RecordFields
                                  singleEntity={
                                    interactionTabs?.length === 1 ? true : false
                                  }
                                  isIncomingCall={true}
                                  currentTab={currentInteractionTab}
                                  selectedProgramId={selectedProgramId}
                                  selectedProductId={selectedProductId}
                                  selectedChannelId={selectedChannelId}
                                  requestorId={requestorId}
                                  setRequestorId={setRequestorId}
                                  isLeftPanel={true}
                                  setViewEntityRecord={setViewEntityRecord}
                                  entityData={entityDataLeft}
                                  setEntityData={setEntityDataLeft}
                                  receivedDate={
                                    communicationData?.created_at
                                      ? new Date(
                                          communicationData.created_at
                                        ).toISOString()
                                      : ''
                                  }
                                  communicationKey={
                                    communicationData?.communication_id ?? ''
                                  }
                                  updatedDataObj={updatedDataObj ?? {}}
                                  initialDataObj={initialDataObj ?? {}}
                                  setEditEntityRecord={setEditEntityRecord}
                                  setAddEntityRecord={setAddEntityRecord}
                                  triggerSearch={triggerSearch}
                                  setTriggerSearch={setTriggerSearch}
                                  interactionStatus={interactionStatus}
                                  isOriginInteraction={true}
                                />
                              </Accordion>
                            </div>
                          ) : null}
                        </div>
                      </>
                    ) : (
                      <div className="overflow-auto">
                        {(viewEntityRecord || addEntityRecord) &&
                        entityDataLeft ? (
                          <div
                            className={`${getClassNameForViewEntitySection(
                              viewEntityRecord,
                              addEntityRecord
                            )}`}
                          >
                            <ViewEntitySection
                              label={
                                PERSON_TYPE_ENTITIES.find(
                                  (entity) =>
                                    entity.label ===
                                    (entityMap[entityDataLeft.label] ??
                                      entityDataLeft.label)
                                )
                                  ? entityDataLeft.label
                                  : ORGANIZATION_ENTITY.label
                              }
                              value={
                                PERSON_TYPE_ENTITIES.find(
                                  (entity) =>
                                    entity.label ===
                                    (entityMap[entityDataLeft.label] ??
                                      entityDataLeft.label)
                                )
                                  ? entityDataLeft.value
                                  : ORGANIZATION_ENTITY.value
                              }
                              setViewEntityRecord={(record) => {
                                setViewEntityRecord(record)
                                setRenderKey((prev) => !prev)
                              }}
                              viewEntityRecord={viewEntityRecord}
                              isCaseCreated={isCaseCreated}
                              editEntityRecord={editEntityRecord}
                              setEditEntityRecord={(value) => {
                                setEditEntityRecord(value)
                              }}
                              addEntityRecord={addEntityRecord}
                              setAddEntityRecord={(value) => {
                                setAddEntityRecord(value)
                              }}
                              setTriggerSearch={setTriggerSearch}
                              setRefetch={setRefetch}
                            />
                          </div>
                        ) : null}
                        {selectedProgramId && selectedChannelId ? (
                          <div className={`${getClassName(viewEntityRecord)}`}>
                            <Accordion
                              heading={
                                CALL_INTERACTIONS.SEARCH_REQUESTOR_INFORMATION
                              }
                              isDefaultActive
                            >
                              <RecordFields
                                singleEntity={
                                  interactionTabs?.length === 1 ? true : false
                                }
                                isIncomingCall={incomingCall}
                                currentTab={currentInteractionTab}
                                selectedProgramId={selectedProgramId}
                                selectedProductId={selectedProductId}
                                selectedChannelId={selectedChannelId}
                                requestorId={requestorId}
                                setRequestorId={setRequestorId}
                                isLeftPanel={true}
                                setViewEntityRecord={setViewEntityRecord}
                                entityData={entityDataLeft}
                                setEntityData={setEntityDataLeft}
                                receivedDate={
                                  communicationData?.created_at
                                    ? new Date(
                                        communicationData.created_at
                                      ).toISOString()
                                    : ''
                                }
                                communicationKey={
                                  communicationData?.communication_id ?? ''
                                }
                                updatedDataObj={updatedDataObj ?? {}}
                                initialDataObj={initialDataObj ?? {}}
                                setEditEntityRecord={setEditEntityRecord}
                                setAddEntityRecord={setAddEntityRecord}
                                triggerSearch={triggerSearch}
                                setTriggerSearch={setTriggerSearch}
                                interactionStatus={interactionStatus}
                                isOriginInteraction={true}
                              />
                            </Accordion>
                          </div>
                        ) : null}
                      </div>
                    )}
                  </div>
                </div>
              </Panel>
              <PanelResizeHandle />
              <Panel
                key={renderKey.toString()}
                className="flex h-full overflow-hidden "
                defaultSize={60}
                minSize={25}
              >
                <div className="flex flex-col w-full min-h-0">
                  <div className="inline-flex items-center gap-2 pb-3 justify-end w-ful">
                    <div className="text-xs font-light font-primary">
                      Client:
                    </div>
                    <div className="box-border rounded bg-secondary-50 text-xs flex justify-center py-2 px-4 font-primary font-light">
                      {selectedTenantName}
                    </div>
                  </div>
                  <div
                    className="flex flex-col w-full border-l border border-[#C8C8C8] rounded-md p-3 flex-1 min-h-0"
                    key={renderRightPanel.toString()}
                  >
                    <div className="ml-auto">
                      <SelectWorkFlowDropDown
                        workflowList={workflowList}
                        updateSelectWorkflow={(
                          selectedWorkflow: WorkflowDefinitionsListType
                        ) => {
                          createWorkflowInstanceForSelected(selectedWorkflow)
                        }}
                        disabled={
                          !checkIfRecordFieldsEnabled(
                            false,
                            updatedDataObj,
                            initialDataObj
                          ) ||
                          interactionStatus?.category_status?.label ===
                            INTERACTION_STATUS?.CANCELLED
                        }
                        isButtonOnTop={true}
                        tabIndex={tabOffsetFromLeftSection}
                      />
                    </div>
                    <div className="overflow-y-auto flex-1 min-h-0">
                      <Tabs
                        tabsWrapperClassName="flex flex-col h-full"
                        tabStyling="shrink-0 whitespace-nowrap"
                        tabsContentClassName="flex-1 overflow-auto"
                        tabs={allTabs}
                        defaultActive={defaultActiveTab}
                        width="max-w-full"
                        onChange={(label, index) => {
                          setDefaultActiveTab(allTabs[index])
                        }}
                        tabIndex={tabOffsetFromLeftSection}
                      ></Tabs>
                    </div>
                  </div>
                </div>
              </Panel>
            </div>
          </PanelGroup>
        </div>
      </FocusTrap>
      <Modal
        isOpen={modal.state}
        closeModal={() => {
          setModal({ message: '', state: false })
          if (modal.onCancelClick) modal.onCancelClick()
        }}
        showCloseButton={true}
        width="w-[38.5rem]"
      >
        <ConfirmationModal
          message={modal.message}
          handleNo={() => {
            setModal({ message: '', state: false })
            if (modal.onCancelClick) modal.onCancelClick()
          }}
          handleYes={() => {
            if (modal.onYesClick) {
              setModal({ message: '', state: false })
              modal.onYesClick()
            } else {
              setModal({ message: '', state: false })
              navigate(`/${callRoute}`)
            }
          }}
        />
      </Modal>
      {showDiscardModal && (
        <ConfirmDialogWithReason
          open={showDiscardModal}
          onCancel={() => setShowDiscardModal(false)}
          onConfirm={handleDiscardConfirm}
          message={NAMESPACES.DISCARD_INTERACTION_CONFIRMATION_MESSAGE}
          width="w-[38.5rem]"
          validationMessage={
            NAMESPACES.DISCARD_INTERACTION_REASON_VALIDATION_MESSAGE
          }
          showCloseButton={true}
        />
      )}
    </CallInteractionContextProvider>
  )
}

interface RecordFieldsProps {
  interactionStatus?: FieldValues
  singleEntity?: boolean
  isIncomingCall?: boolean
  currentTab?: TabInterface
  selectedProgramId?: string
  selectedProductId?: string
  selectedChannelId?: string
  requestorId?: number | null
  setRequestorId?: (requestorId: number) => void
  isLeftPanel?: boolean
  setViewEntityRecord?: React.Dispatch<
    React.SetStateAction<DataTypeStore | undefined>
  >
  entityData?: EntityDataProps
  setEntityData?: React.Dispatch<
    React.SetStateAction<EntityDataProps | undefined>
  >
  handleCreateWorkflowInstance?: (
    process: WorkflowProcessType,
    instance: WorkflowInstanceType
  ) => void
  receivedDate: string
  tabIndex?: number
  communicationKey?: string
  updatedDataObj?: React.MutableRefObject<{
    channel: string | undefined
    product: string | undefined
    program: string | undefined
    requestor: string | undefined
  }>
  initialDataObj?: React.MutableRefObject<{
    channel: string | undefined
    product: string | undefined
    program: string | undefined
    requestor: string | undefined
  }>
  setEditEntityRecord?: React.Dispatch<
    React.SetStateAction<boolean | undefined>
  >
  setAddEntityRecord?: React.Dispatch<React.SetStateAction<boolean | undefined>>
  triggerSearch?: boolean | undefined
  setTriggerSearch?: React.Dispatch<React.SetStateAction<boolean | undefined>>
  isOriginInteraction?: boolean
}

const RecordFields = ({
  singleEntity,
  isIncomingCall,
  currentTab,
  selectedProgramId,
  selectedProductId,
  selectedChannelId,
  requestorId,
  setRequestorId,
  isLeftPanel,
  setViewEntityRecord,
  entityData,
  setEntityData,
  handleCreateWorkflowInstance,
  receivedDate,
  tabIndex,
  communicationKey,
  updatedDataObj,
  initialDataObj,
  setEditEntityRecord,
  setAddEntityRecord,
  triggerSearch,
  setTriggerSearch,
  interactionStatus,
  isOriginInteraction,
}: RecordFieldsProps) => {
  const { viewEntityRecord } = useContext(CallInteractionContext)
  const [renderKey, setRenderKey] = useState<boolean>(false)
  const [entityOptions, setEntityOptions] = useState<DropdownType<string>[]>([])
  const [entityDataInner, setEntityDataInner] = useState<
    EntityDataProps | undefined
  >(isLeftPanel ? undefined : entityData)
  const [selectedRecord, setSelectedRecord] = useState<string>()

  const dispatch = useAppDispatch()
  const entitiesList = useAppSelector(
    (state: RootState) => state.entity.entitiesByName
  )

  const handleRecordTypeChange = async (e: DropdownType<unknown, string>) => {
    setSelectedRecord(e?.value)
    if (e.value === 'person') {
      setEntityOptions(PERSON_TYPE_ENTITIES)
      setEntityData?.(undefined)
      setEntityDataInner(undefined)
    } else if (e.value === 'organization') {
      dispatch(showLoader())
      try {
        const response = await getEntityList({
          entity_name: 'organization_type',
          embedded_name: 'name',
        })
        if (response.data) {
          setEntityOptions(
            response?.data?.content?.map(
              (item: { id: number; name: string }) => ({
                label: item.name,
                value: item.id.toString(),
              })
            )
          )
        }
      } catch (err) {
        console.log(err)
      } finally {
        dispatch(hideLoader())
      }
      setEntityData?.(undefined)
      setEntityDataInner(undefined)
    } else {
      setEntityOptions([CASE_ENTITY])
      setEntityData?.(CASE_ENTITY)
      setEntityDataInner(CASE_ENTITY)
    }
    setRenderKey((prev) => !prev)
  }
  const handleEntityChange = (e: DropdownType<unknown, string>) => {
    setEntityData?.({
      label: e.label,
      value: e.value,
    })
    setEntityDataInner({
      label: e.label,
      value: e.value,
    })
    setRenderKey((prev) => !prev)
  }
  const getDataQaId = (isLeftPanel: boolean | undefined) =>
    isLeftPanel ? 'left' : 'right'

  useEffect(() => {
    if (currentTab) {
      setEntityData?.({
        label:
          currentTab?.label === 'Providers'
            ? 'Provider'
            : currentTab?.label === 'contact'
            ? 'Contact'
            : String(currentTab.label),
        value: String(currentTab?.id),
      })
      setEntityDataInner({
        label:
          currentTab?.label === 'Providers'
            ? 'Provider'
            : currentTab?.label === 'contact'
            ? 'Contact'
            : String(currentTab.label),
        value: String(currentTab?.id),
      })
      setRenderKey((prev) => !prev)
    }
    setTriggerSearch?.((prev) => !prev)
  }, [currentTab])

  useEffect(() => {
    const requiredViewEntities: string[] = [
      ENTITY_NAME.PROVIDER_VIEW_KEY,
      ENTITY_NAME.PATIENT_ENROLLMENT_VIEW_KEY,
      ENTITY_NAME.CASE_VIEW_KEY,
      ENTITY_NAME.PHARMACY_VIEW_KEY,
      ENTITY_NAME.FACILITIES_VIEW_KEY,
    ]

    const allEntities = Object.values(entitiesList)
    const viewEntities = allEntities.filter((entity) =>
      requiredViewEntities.includes(entity.name)
    )

    if (viewEntities.length < requiredViewEntities.length) {
      dispatch(getAllEntitiesAgentAction())
    }
  }, [])

  return (
    <div>
      <div className="grid grid-cols-3 gap-x-3 py-5 px-3">
        {!isLeftPanel ? (
          <SelectDropDown
            label="Entity Type"
            options={[
              {
                label: 'Person',
                value: 'person',
              },
              {
                label: 'Organization',
                value: 'organization',
              },
              {
                label: 'Case',
                value: 'case',
              },
            ]}
            name=""
            onChange={(e) => handleRecordTypeChange(e)}
            required
            dataQaId={`requestor-record-type-${getDataQaId(isLeftPanel)}`}
            defaultValue={selectedRecord}
            disabled={
              !checkIfRecordFieldsEnabled(
                isLeftPanel,
                updatedDataObj,
                initialDataObj
              ) ||
              interactionStatus?.category_status?.label ===
                INTERACTION_STATUS?.CANCELLED
            }
            tabIndex={tabIndex ?? 0}
          />
        ) : null}
        <SelectDropDown
          label={'Entity'}
          options={isLeftPanel ? PERSON_TYPE_ENTITIES : entityOptions}
          onChange={handleEntityChange}
          name=""
          required
          dataQaId={`requestor-entity-${isLeftPanel ? 'left' : 'right'}`}
          isSearchable
          defaultValue={
            currentTab?.id
              ? String(currentTab?.id)
              : entityDataInner?.value ?? ''
          }
          disabled={
            !checkIfRecordFieldsEnabled(
              isLeftPanel,
              updatedDataObj,
              initialDataObj
            ) ||
            interactionStatus?.category_status?.label ===
              INTERACTION_STATUS?.CANCELLED
          }
          tabIndex={tabIndex ?? 0}
        />
      </div>
      {entityDataInner && (isLeftPanel || selectedRecord) && (
        <div className="pb-5 px-3" key={renderKey.toString()}>
          <SearchLayout
            singleEntity={singleEntity}
            entity_id={
              selectedRecord === 'organization'
                ? ORGANIZATION_ENTITY.value
                : entityDataInner.value
            }
            entity_name={
              selectedRecord === 'organization'
                ? ORGANIZATION_ENTITY.label
                : entityDataInner.label
            }
            organizationType={
              selectedRecord === 'organization' ? entityDataInner : undefined
            }
            selectedProgramId={selectedProgramId}
            selectedProductId={selectedProductId}
            selectedChannelId={selectedChannelId}
            requestorId={requestorId}
            setRequestorId={setRequestorId}
            isLeftPanel={isLeftPanel}
            setViewEntityRecord={setViewEntityRecord}
            viewEntityRecord={viewEntityRecord}
            handleCreateWorkflowInstance={handleCreateWorkflowInstance}
            receivedDate={receivedDate}
            tabIndex={tabIndex}
            communicationKey={communicationKey}
            setEditEntityRecord={setEditEntityRecord}
            setAddEntityRecord={setAddEntityRecord}
            triggerSearch={triggerSearch}
            isIncomingCall={isIncomingCall}
            currentInteractionTab={currentTab}
            isOriginInteraction={isOriginInteraction}
          />
        </div>
      )}
    </div>
  )
}

export const PERSON_TYPE_ENTITIES = [
  {
    label: 'Patient',
    value: '18',
  },
  {
    label: 'Provider',
    value: '4',
  },
  {
    label: 'Contact',
    value: '998',
  },
]

export const ORGANIZATION_ENTITY = {
  label: 'Organization',
  value: '997',
}

const CASE_ENTITY = {
  label: 'Case',
  value: '32',
}

const ViewEntitySection = (props: EntityDataProps | undefined) => {
  const { tabs, setTabOffset } = useContext(CallInteractionContext)
  const dispatch = useAppDispatch()
  const requestorConfig = useAppSelector(
    (state: RootState) => state.requestor.payload
  )
  const [layout, setLayout] = useState<LayoutResponseType | undefined>()
  const [editLayout, setEditLayout] = useState<LayoutResponseType | undefined>()
  const allLayouts = useRef<LayoutResponseType[]>([])
  const [viewData, setViewData] = useState<FieldValues>()
  const [renderKey, setRenderKey] = useState<boolean>(false)
  const [isBackButtonDisabled, setIsBackButtonDisabled] = useState(
    !!tabs?.length
  )
  const [isDuplicateModalOpen, setIsDuplicateModalOpen] =
    useState<boolean>(false)
  const [viewLayout, setViewLayout] = useState<LayoutResponseType>()
  const [viewRecordData, setViewRecordData] = useState<FieldValues>()
  const [listingLayout, setListingLayout] = useState<LayoutResponseType>()
  const [selectedRow, setSelectedRow] = useState<ListingTableRow | null>(null)
  const [addedRecord, setAddedRecord] = useState<FieldValues | null>(null)
  const [viewDuplicateRecord, setViewDuplicateRecord] = useState<boolean>(false)
  const [refetchKey, setRefetchKey] = useState<number>(0)
  const [totalRecords, setTotalRecords] = useState<number>(0)
  const entitiesByName = useAppSelector(
    (state: RootState) => state.entity.entitiesByName
  )

  const extraColumn: ListingTableColumn[] = [
    {
      header: '',
      accessor: DUPLICATION.SELECT_ACCESSOR,
      type: DUPLICATION.RADIO_TYPE,
      onClick(_KeyName, row, _rowIndex) {
        setSelectedRow(row)
        setRefetchKey((prev) => prev + 1)
      },
    },
    {
      header: APPLICATION_PREFERENCES_STRINGS.MATCH_SCORE,
      accessor: DUPLICATION.SCORE_ACCESSOR,
      type: DUPLICATION.COMPONENT_TYPE,
      renderComponent: (row) => {
        return (
          <div className="flex items-center gap-1">
            <span>{String(row?.score ?? '')}</span>
            <DuplicationScore
              groups={row?.matchDetails as unknown as Group[]}
            />
          </div>
        )
      },
    },
  ]

  const extraActions: (TableActionType<DataTypeStore> & {
    onClick?: (row: ListingTableRow, rowIndex: number) => void
  })[] = [
    {
      label: NAMESPACES.VIEW,
      key: ACTION_ICONS_NAMESPACE.VIEW,
      onClick: async (row) => {
        const layoutId = await fetchViewLayout()
        setSelectedRow(row)
        setViewDuplicateRecord(true)
        fetchViewRecordData(layoutId, row?.id)
      },
    },
  ]

  const requestorPayload = (
    row: DataTypeStore,
    function_parameters?: FieldValues
  ) => ({
    entity_name: 'requestor_view',
    select: ['name', 'record_id', 'record_key', 'entity_type'],
    page: 0,
    size: 1,
    filters: [
      {
        criteria: [
          {
            field_name: 'record_key',
            operation: 'LIKE',
            values: [
              (row?.['Patient ID'] ||
                row?.patient_key ||
                row?.['Provider ID'] ||
                row?.provider_key ||
                row?.['Facility ID'] ||
                row?.case_key ||
                row?.contact_key ||
                row?.organization_key ||
                '') as string,
            ],
          },
        ],
      },
    ],
    ...(function_parameters ? { function_parameters } : {}),
  })

  const requestorPayloadAdd = (
    id: number | string,
    entityType: string,
    function_parameters?: FieldValues
  ) => ({
    entity_name: 'requestor_view',
    select: ['name', 'record_id', 'record_key', 'entity_type'],
    page: 0,
    size: 1,
    filters: [
      {
        criteria: [
          {
            field_name: 'record_id',
            operation: 'LIKE',
            values: [id as string],
          },
          {
            field_name: 'entity_type',
            operation: 'LIKE',
            values: [entityType],
          },
        ],
      },
    ],
    ...(function_parameters ? { function_parameters } : {}),
  })

  const fetchAndSetRequestorData = async (
    row: DataTypeStore,
    id?: string | number,
    entityType?: string
  ) => {
    dispatch(showLoader())
    dispatch(updateRequestorConfigReducer({ row, id, entityType }))
    const response = await getEntityDataByEntityNameApiForFilter({
      payload:
        id && entityType
          ? requestorPayloadAdd(id, entityType, editLayout?.function_parameters)
          : requestorPayload(row, editLayout?.function_parameters),
    })
    const updatedResponse = reverseMappingOfRequestorName(response.data.content)
    if (!response?.data?.content?.length) {
      dispatch(
        addToaster({
          id: uniqueId(),
          message: REQUESTOR_MESSAGES.REQUESTOR_FAIL,
          type: 'error',
        })
      )
    } else {
      dispatch(
        addToaster({
          id: uniqueId(),
          message: REQUESTOR_MESSAGES.REQUESTOR_SUCCESS,
          type: 'success',
        })
      )
    }
    if (id)
      row = {
        id: id,
      }
    if (entityType)
      row = {
        ...row,
        entity_type: entityType,
      }
    props?.setViewEntityRecord?.({
      ...row,
      entity_type: updatedResponse?.[0]?.entity_type,
      requestor_id: updatedResponse?.[0]?.id,
    })
    dispatch(hideLoader())
  }

  const handleEditModalData = async (values: FieldValues) => {
    try {
      props?.setTriggerSearch?.(false)
      dispatch(showLoader())
      await editEntityData(
        props?.label ?? '',
        Number(props?.value),
        layout?.id ?? 0,
        values,
        ((props?.viewEntityRecord?.record_id ??
          props?.viewEntityRecord?.id) as number) ?? '',
        []
      )
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.EDIT_SUCCESS,
          type: 'success',
          id: uuid(),
        })
      )
      fetchEntityData()
      setRenderKey((prev) => !prev)
    } catch (err) {
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.FAILED_TO_EDIT_RECORD,
          type: 'error',
          id: uuid(),
        })
      )
    } finally {
      dispatch(hideLoader())
      props?.setTriggerSearch?.(true)
      props?.setViewEntityRecord?.(undefined)
      props?.setEditEntityRecord?.(false)
      props?.setAddEntityRecord?.(false)
    }
  }

  const fetchListingLayout = async () => {
    try {
      const res = await getLayoutByEntityIdAndTypeApi({
        entityId: editLayout?.entity_id.toString() ?? '',
        type: LAYOUT_TYPE_NAMESPACE?.LAYOUT_LISTING,
        isDefault: true,
      })
      if (res?.data) {
        setListingLayout(res.data?.[0])
        return res.data?.[0]
      }
    } catch (err) {
      console.log(err)
    }
  }

  const fetchTableDataCallback = async (
    values: FieldValues,
    listingLayoutId: string | number,
    payload?: getEntityDataByEntityFilter['payload'] & { layout_id: number }
  ) => {
    if (listingLayoutId) {
      const duplicateApiPayload = transformToDuplicateApiPayload(
        values,
        editLayout?.entity_id?.toString() ?? '',
        listingLayoutId.toString() ?? '',
        editLayout
      )
      const res = await fetchDuplicateRecordsAPI(
        editLayout?.entity_id ?? 0,
        duplicateApiPayload,
        payload?.page as number,
        payload?.size as number
      )
      const addSelectedFlag = (data: ListingTableRow[]) => {
        return data.map((row) => ({
          ...row,
          select: row?.id === selectedRow?.id ? true : false,
        }))
      }
      res.data.content = addSelectedFlag(res?.data?.content)
      setTotalRecords(res?.data?.totalElements ?? 0)

      if (res?.data?.content.length != 0) {
        setAddedRecord(values)
        setIsDuplicateModalOpen(true)
      } else {
        createNewRecord(values)
      }

      return res?.data
    }
  }

  const handleFormSubmit = async (
    finalvalues: FieldValues,
    _embedded: string[],
    originalFormData: FieldValues | undefined
  ) => {
    dispatch(showLoader())
    try {
      const values = { ...finalvalues, ...originalFormData }
      const entity = entitiesByName[editLayout?.entity_name ?? '']
      if (!props?.editEntityRecord) {
        const flagValue = validatePhoneNumberAndAddress(values, dispatch)
        if (flagValue) {
          return
        }
      }
      if (props?.editEntityRecord) {
        handleEditModalData(values)
      } else if (entity?.is_duplicate) {
        const listingLayout = await fetchListingLayout()
        await fetchTableDataCallback(values, listingLayout?.id)
      } else {
        handleAddEntityData(values)
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const closeAndMoveToAdvancedSearch = (
    id?: string | number,
    entityType?: string
  ) => {
    dispatch(showLoader())
    setAddedRecord(null)
    setIsDuplicateModalOpen(false)
    setViewDuplicateRecord(false)
    if (!selectedRow && id) {
      dispatch(updateRequestorConfigReducer({ id, entityType }))
      setTimeout(() => {
        fetchAndSetRequestorData(
          selectedRow as unknown as DataTypeStore,
          id,
          entityType
        )
        dispatch(hideLoader())
      }, 4000)
    } else {
      dispatch(updateRequestorConfigReducer({ selectedRow }))
      fetchAndSetRequestorData(selectedRow as DataTypeStore, id, entityType)
      dispatch(hideLoader())
    }
    props?.setEditEntityRecord?.(false)
    props?.setAddEntityRecord?.(false)
    fetchEntityData()
  }

  const createNewRecord = async (values?: FieldValues) => {
    dispatch(showLoader())
    try {
      const res = await addEntityData(
        editLayout?.entity_name ?? '',
        Number(editLayout?.entity_id),
        Number(editLayout?.id),
        addedRecord ?? values ?? {}
      )
      if (res?.data) {
        addToaster({
          id: uniqueId(),
          message: TOASTER_NAMESPACE?.ADD_SUCCESS,
          type: 'success',
        })
        closeAndMoveToAdvancedSearch(res.data.id, editLayout?.entity_name ?? '')
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchViewLayout = async () => {
    dispatch(showLoader())
    try {
      const res = await getLayoutByEntityIdAndTypeApi({
        entityId: String(editLayout?.entity_id),
        type: LAYOUT_TYPE_NAMESPACE?.OVERVIEW_TYPE,
        isDefault: true,
      })
      if (res?.data) {
        setViewLayout(res?.data?.[0])
        return res?.data?.[0]?.id
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchViewRecordData = async (layoutId: number, id: number) => {
    dispatch(showLoader())
    try {
      const res = await getEntityData(
        String(editLayout?.entity_name),
        Number(editLayout?.entity_id),
        layoutId,
        id
      )
      if (res?.data) {
        setViewRecordData(res?.data)
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const triggerFormSubmit = () => {
    const adjacentDiv = document.getElementById('requestor-edit-form')
    const form =
      adjacentDiv?.nextElementSibling?.tagName === 'FORM'
        ? adjacentDiv.nextElementSibling
        : adjacentDiv?.nextElementSibling?.querySelector('form')
    if (form) {
      ;(form as HTMLFormElement).requestSubmit()
    }
  }

  const handleAddEntityData = async (values: FieldValues) => {
    try {
      dispatch(showLoader())
      await addEntityData(
        props?.label ?? '',
        Number(props?.value),
        layout?.id ?? 0,
        values,
        []
      )
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.ADD_SUCCESS,
          type: 'success',
          id: uuid(),
        })
      )
    } catch (err) {
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.FAILED_TO_ADD_RECORD,
          type: 'error',
          id: uuid(),
        })
      )
      console.error(err)
    } finally {
      dispatch(hideLoader())
      props?.setTriggerSearch?.(true)
      props?.setViewEntityRecord?.(undefined)
      props?.setEditEntityRecord?.(false)
      props?.setAddEntityRecord?.(false)
    }
  }

  const fetchEntityData = async () => {
    try {
      const viewEntityData = await getEntityData(
        props?.label ?? '',
        Number(props?.value),
        layout?.id ?? 0,
        (props?.viewEntityRecord?.record_id as number) ??
          selectedRow?.record_id ??
          (props?.viewEntityRecord?.id as number) ??
          selectedRow?.id ??
          ''
      )
      setViewData(viewEntityData?.data)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    const fetchLayouts = async (): Promise<LayoutResponseType[]> => {
      try {
        dispatch(showLoader())
        const response = await getAllLayoutApi({
          entityId: props?.value?.toString(),
          defaultValue: true,
        })
        return response.data.content ?? []
      } catch (err) {
        console.error(err)
        return []
      } finally {
        dispatch(hideLoader())
      }
    }

    const updateLayouts = async () => {
      allLayouts.current = await fetchLayouts()
      allLayouts.current.forEach((layout) => {
        if (
          layout.type === LAYOUT_TYPE_NAMESPACE.OVERVIEW_TYPE &&
          layout.default_value
        ) {
          setLayout(layout)
        }
        if (
          layout.type === LAYOUT_TYPE_NAMESPACE.DEFAULT_VIEW_EDIT &&
          layout.default_value
        ) {
          setEditLayout(layout)
        }
      })
    }
    updateLayouts()
  }, [])

  useEffect(() => {
    if (layout) {
      fetchEntityData()
      const indexMap = generateTabIndexMap(
        layout?.layout_data?.pages as unknown as Page[]
      )
      const maxIndexVaue = getMaxTabIndexValue({ indexMap })
      setTabOffset &&
        setTabOffset(maxIndexVaue ? maxIndexVaue + ROWS_TAB_DIFFERENCE : 0)
    }
  }, [layout])

  useEffect(() => {
    if (props?.isCaseCreated) {
      setIsBackButtonDisabled(true)
    }
  }, [props?.isCaseCreated])

  return (
    <div>
      <div className="flex items-center justify-between pb-2">
        {!isDuplicateModalOpen ? (
          <div className="flex items-center gap-1 w-full">
            <div
              className={`${
                isBackButtonDisabled
                  ? 'opacity-30 cursor-not-allowed'
                  : 'cursor-pointer'
              } `}
            >
              <span
                className="font-medium text-base font-primary"
                onClick={() => {
                  if (isBackButtonDisabled) return
                  props?.setViewEntityRecord?.(undefined)
                  props?.setEditEntityRecord?.(false)
                  props?.setAddEntityRecord?.(false)
                  props?.setRefetch?.((prev) => prev + 1)
                }}
                onKeyDown={(e) => {
                  if (
                    e?.key === ShortcutKeys.Enter ||
                    e.key === ShortcutKeys.Space
                  ) {
                    if (isBackButtonDisabled) return
                    props?.setViewEntityRecord?.(undefined)
                    props?.setEditEntityRecord?.(false)
                    props?.setAddEntityRecord?.(false)
                    e?.preventDefault()
                  }
                }}
                tabIndex={isBackButtonDisabled ? -1 : 0}
              >
                {APPLICATION_PREFERENCES_STRINGS.ADVANCED_SEARCH}
              </span>
            </div>
            <div>
              <span
                className={`font-medium text-sm font-primary cursor-pointer ${
                  props?.viewEntityRecord || props?.addEntityRecord
                    ? 'text-primary-500'
                    : ''
                }`}
              >
                {`/ ${
                  props?.editEntityRecord
                    ? NAMESPACES.EDIT
                    : props?.addEntityRecord
                    ? NAMESPACES.ADD
                    : NAMESPACES.VIEW
                } ${props?.label}`}
              </span>
            </div>
            {props?.viewEntityRecord &&
              !props?.viewEntityRecord?.requestor_id && (
                <div
                  className="ml-auto cursor-pointer"
                  onClick={() =>
                    !isEmpty(requestorConfig?.id) &&
                    !isEmpty(requestorConfig?.entityType)
                      ? fetchAndSetRequestorData(
                          requestorConfig?.row ?? {},
                          requestorConfig?.id ?? '',
                          requestorConfig?.entityType ?? ''
                        )
                      : fetchAndSetRequestorData(requestorConfig?.row ?? {})
                  }
                >
                  <SvgReload />
                </div>
              )}
          </div>
        ) : (
          <div>
            <span
              className="font-medium text-base font-primary cursor-pointer"
              onClick={() => {
                props?.setViewEntityRecord?.(undefined)
                props?.setEditEntityRecord?.(false)
                props?.setAddEntityRecord?.(false)
              }}
              onKeyDown={(e) => {
                if (
                  e?.key === ShortcutKeys.Enter ||
                  e.key === ShortcutKeys.Space
                ) {
                  props?.setViewEntityRecord?.(undefined)
                  props?.setEditEntityRecord?.(false)
                  props?.setAddEntityRecord?.(false)
                }
              }}
              tabIndex={0}
            >
              {APPLICATION_PREFERENCES_STRINGS?.ADVANCED_SEARCH}
            </span>
            <span
              className={`font-medium text-base font-primary cursor-pointer`}
              onClick={() => {
                setViewDuplicateRecord(false)
                setIsDuplicateModalOpen(false)
                setSelectedRow(null)
                props?.setEditEntityRecord?.(false)
              }}
            >
              {`/ ${NAMESPACES.ADD} ${props?.label} / `}
            </span>
            <span
              className={`font-medium text-sm font-primary cursor-pointer ${
                !viewDuplicateRecord ? `text-primary-500` : ``
              }`}
              onClick={() => {
                setViewDuplicateRecord(false)
              }}
            >
              {APPLICATION_PREFERENCES_STRINGS?.DUPLICATE_HEADING}
            </span>
            {viewDuplicateRecord && (
              <span className="font-medium text-base font-primary cursor-pointer text-primary-500">
                {` / ${NAMESPACES.VIEW} ${props?.label}`}
              </span>
            )}
          </div>
        )}
        {props?.editEntityRecord ? (
          <div className="flex gap-3">
            <CustomButton
              className="!h-[1.75rem]"
              onClick={() => {
                props?.setViewEntityRecord?.(undefined)
                props?.setEditEntityRecord?.(false)
                props?.setAddEntityRecord?.(false)
              }}
            >
              {BUTTONS.CANCEL}
            </CustomButton>
            <CustomButton
              isFilled={true}
              className="!h-[1.75rem]"
              type="submit"
              onClick={triggerFormSubmit}
            >
              {BUTTONS.UPDATE}
            </CustomButton>
          </div>
        ) : props?.addEntityRecord ? (
          isDuplicateModalOpen ? (
            <div className="flex gap-2">
              <CustomButton isFilled onClick={createNewRecord}>
                {APPLICATION_PREFERENCES_STRINGS?.CREATE_ANYWAY}
              </CustomButton>
              <CustomButton
                isFilled
                onClick={() => {
                  closeAndMoveToAdvancedSearch()
                }}
                disabled={isEmpty(selectedRow)}
              >
                {APPLICATION_PREFERENCES_STRINGS?.USE_EXISTING}
              </CustomButton>
            </div>
          ) : (
            <div>
              <CustomButton
                isFilled
                type="submit"
                className="!h-[1.75rem]"
                onClick={() => {
                  triggerFormSubmit()
                }}
              >
                {BUTTONS.SAVE}
              </CustomButton>
            </div>
          )
        ) : null}
      </div>
      {(props?.editEntityRecord ||
        props?.addEntityRecord ||
        props?.viewEntityRecord) &&
      !isDuplicateModalOpen ? (
        <FormRenderer
          layout={
            (props?.editEntityRecord || props?.addEntityRecord
              ? editLayout?.layout_data
              : layout?.layout_data) as LayoutData
          }
          mode={
            props?.editEntityRecord
              ? MODE_CONSTANTS.EDIT
              : props?.addEntityRecord
              ? MODE_CONSTANTS.ADD
              : MODE_CONSTANTS.VIEW
          }
          fullLayout={
            (props?.editEntityRecord || props?.addEntityRecord
              ? editLayout
              : layout) as EntityLayout
          }
          heading={null}
          handleFormSubmit={handleFormSubmit}
          data={props?.addEntityRecord ? addedRecord : viewData}
          key={renderKey.toString()}
          formUniqueId="requestor-edit-form"
        />
      ) : null}
      {isDuplicateModalOpen &&
        (!viewDuplicateRecord ? (
          <>
            <span className="font-light text-xs pb-2">
              {totalRecords}{' '}
              {totalRecords > 1
                ? `${APPLICATION_PREFERENCES_STRINGS.RECORD}s`
                : APPLICATION_PREFERENCES_STRINGS.RECORD}
              {` ${APPLICATION_PREFERENCES_STRINGS.FOUND}`}
            </span>
            <ListingTable
              entityId={Number(editLayout?.entity_id)}
              entityName={editLayout?.entity_name ?? ''}
              extraActions={extraActions}
              layout={listingLayout}
              dataFetchCallback={(payload) =>
                fetchTableDataCallback(
                  addedRecord ?? {},
                  listingLayout?.id ?? 0,
                  payload
                )
              }
              extraColumns={extraColumn}
              hideFilters={true}
              refetchKey={refetchKey}
              openInNewTab={true}
            />
          </>
        ) : (
          <FormRenderer
            heading={null}
            layout={viewLayout?.layout_data as LayoutData}
            mode={MODE_CONSTANTS?.VIEW}
            handleFormSubmit={noop}
            fullLayout={viewLayout as EntityLayout}
            data={viewRecordData}
          />
        ))}
    </div>
  )
}
